import { Koi } from '@ksyos/koi';
import type { IServiceActivity } from '@common/interfaces';
import type { AddEdit } from '@common/utils/utilityTypes';
import { PayoutRecipient } from '@common/enums';
import type { ISchemaContainer } from './schemaContainer';
import { replaceKoiError } from './replaceKoiError';

export type PayableServiceActivity = PayableServiceActivityValidatedAddEdit & {
    conditionalServiceActivity?: IServiceActivity;
    id: string;
    serviceActivity: IServiceActivity;
    serviceId: string;
};

export const validCompensationPayoutRecipient = [PayoutRecipient.organization, PayoutRecipient.practitioner] as const;

export type PayableServiceActivityAddEdit = AddEdit<PayableServiceActivityValidatedAddEdit>;

export type PayableServiceActivityValidatedAddEdit = {
    conditionalServiceActivityId?: string | null;
    endDate: string | null;
    payoutRecipient: PayoutRecipient.organization | PayoutRecipient.practitioner;
    serviceActivityId: string;
    startDate: string;
};

export const payableServiceActivityValidationSchema = Koi.object({
    conditionalServiceActivityId: Koi.string()
        .uuid()
        .allow(null)
        .optional()
        .invalid(Koi.ref('serviceActivityId'))
        .error((errors) => replaceKoiError(errors, 'any.invalid', 'serviceActivity.same')),
    endDate: Koi.koi().endDate().allow(null),
    payoutRecipient: Koi.valid(...validCompensationPayoutRecipient).required(),
    serviceActivityId: Koi.string().uuid().required(),
    startDate: Koi.koi().date().required(),
});

export const payableServiceActivitySchema: ISchemaContainer<PayableServiceActivityValidatedAddEdit> = {
    schema: payableServiceActivityValidationSchema.options({ convert: false, presence: 'required' }),
};
